<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payment Details"
      text="Update payment details"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                :value="companyEmployee.company.payroll_banks[0].payroll_bank.name"
                disabled
                label="Company Payroll Bank"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localPaymentMode"
                outlined
                label="Payment Mode"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localBankCode"
                outlined
                label="Bank Code"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        localPaymentMode: null,
        localBankCode: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localPaymentMode = this.companyEmployee.payment_mode 
        this.localBankCode = this.companyEmployee.bank_code 

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisCompanyEmployees().updateCompanyEmployee(this.companyEmployee.company_employee_uid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          payment_mode: this.localPaymentMode,
          bank_code: this.localBankCode,
        }
      },
    },
  }
</script>
